import { Button } from '@/components/ui/button';
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '@/components/ui/modal';

interface ChatImagePhiReminderModalProps {
  open: boolean;
  onClose: () => void;
}

// One-time reminder shown the first time a user attaches an image in chat.
// Gated + recorded via the message-state system (key
// `chat-image-phi-reminder`); this component is purely presentational.
const ChatImagePhiReminderModal: React.FC<ChatImagePhiReminderModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      name="chat-image-phi-reminder"
      className="modal--glass"
    >
      <ModalHeader>
        <h2>No PII or PHI</h2>
      </ModalHeader>
      <ModalBody>
        <p className="!m-0">
          Reminder: Do not upload PHI (protected health information) or other
          sensitive personal data, including real patient names, faces, or
          identifiers. Ora is not a clinical tool and should only receive
          de-identified study material.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button context="modal" onClick={onClose}>
          I Understand
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ChatImagePhiReminderModal;
